import { FunctionComponent } from 'react';

import { useBundle } from '@amzn/react-arb-tools';

import { MenuItem } from 'src/components/common/menu-item/MenuItem';
import { useFooterNavItems } from 'src/components/footer/hooks/use-footer-nav-items';
import { NAV_MENU_IDS, NAV_PLACEMENT } from 'src/enums/navigation';
import { RESOURCE_BUNDLES } from 'src/enums/resource-bundles';
import { THEME } from 'src/enums/theme';
import { tf } from 'src/helpers';

import styles from './Footer.module.scss';

/**
 * Items in the menu are flex positioned and right align is applied using "margin-left: auto".
 * The behavior is that every item starting with the one with the right align class
 * are shifted to the right. Keep in mind for NRS menu item ordering.
 */
const RIGHT_ALIGN_STARTING = NAV_MENU_IDS.COOKIE_POLICY;

export const Footer: FunctionComponent = () => {
  const { navItems } = useFooterNavItems();
  const [bundle] = useBundle(RESOURCE_BUNDLES.FOOTER);

  return (
    <footer className={styles.footer}>
      <nav aria-label={tf(bundle, 'secondary_label', 'Secondary navigation')} className={styles.navigation}>
        <ul className={styles.listContainer}>
          {navItems.map((item) => (
            <MenuItem
              isAlignedRight={item.id === RIGHT_ALIGN_STARTING}
              key={item.id}
              navItem={item}
              placement={NAV_PLACEMENT.FOOTER}
              theme={THEME.LIGHT}
              resourceBundle={RESOURCE_BUNDLES.FOOTER}
            />
          ))}
        </ul>
      </nav>
    </footer>
  );
};
